import { render, staticRenderFns } from "./h5SinglePartList.vue?vue&type=template&id=13a33150&scoped=true"
import script from "./h5SinglePartList.vue?vue&type=script&lang=js"
export * from "./h5SinglePartList.vue?vue&type=script&lang=js"
import style0 from "./h5SinglePartList.vue?vue&type=style&index=0&id=13a33150&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a33150",
  null
  
)

export default component.exports